import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "./footer";
import MapSection from "./mapSection";
import Nav from "./nav";
import AccommodationCard from "./accomodationCard";
import AccommodationList from "./accomadtionList";

function VenueTabs() {
  return (
    <div>
      <div className="container my-5">
        <h2 className="text-center mb-4">Venue Information</h2>
        <ul className="nav nav-tabs" id="venueTabs" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active"
              id="details-tab"
              data-bs-toggle="tab"
              data-bs-target="#details"
              type="button"
              role="tab"
              aria-controls="details"
              aria-selected="true"
            >
              Venue
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="flights-tab"
              data-bs-toggle="tab"
              data-bs-target="#flights"
              type="button"
              role="tab"
              aria-controls="flights"
              aria-selected="false"
            >
              Flights
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="accommodations-tab"
              data-bs-toggle="tab"
              data-bs-target="#accommodations"
              type="button"
              role="tab"
              aria-controls="accommodations"
              aria-selected="false"
            >
              Accommodations
            </button>
          </li>
        </ul>
        <div className="tab-content" id="venueTabsContent">
          <div
            className="tab-pane fade show active"
            id="details"
            role="tabpanel"
            aria-labelledby="details-tab"
          >
            <div className="p-4">
              <h3>The Venue</h3>
              <p>
                This conference venue can accommodate up to 2500 delegates. It
                has an outdoor auditorium, on site chef and dedicated staff. The
                Mittah Seperepere Convention Centre is capable of hosting big
                meetings of any level of importance, including international
                conference To top it all this conference venue is situated
                directly opposite the world renowned Kimberley Big Hole and 4
                star accommodation. The facility was designed to be
                multifunctional and can provide a large flat floor area suitable
                for events such as: ballroom dancing, boxing, martial arts and
                gymnastics.
              </p>

              <h5>ADDRESS</h5>
              <p>10W Circular Rd, Wesrt End</p>
              <p>Kimberley , 8301</p>
              <MapSection />
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="flights"
            role="tabpanel"
            aria-labelledby="flights-tab"
          >
            <div className="p-4">
              <h3>OUR AIRLINE PARTNER</h3>

              <div className="row">
                <div></div>
                <div></div>
              </div>
              <p>
                Include details about flights, airport information, and travel
                tips here.
              </p>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="accommodations"
            role="tabpanel"
            aria-labelledby="accommodations-tab"
          >
            <div className="p-4">
              <h3>Accommodations</h3>
              <p>
                Provide a list of nearby hotels, guesthouses, and lodging
                options here.
              </p>

              <AccommodationList />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default VenueTabs;
